// extracted by mini-css-extract-plugin
export default {"goalInput":"ProfileNodeGoalEditComponent_goalInput__TwVFK","progressText":"ProfileNodeGoalEditComponent_progressText__qmBlS"};